export const en = {
  // Purchased Cars (Win Cars) view tabs
  winCarsView: {
    ourDealers: 'Our Dealers',
    allAuctionWins: 'All Auction Wins',
    ourDealersHint: 'Only vehicles purchased by or assigned to our registered dealers.',
    allAuctionWinsHint: 'All cars from the auction feed (reference data).',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    branches: 'Branches',
    managers: 'Managers',
    dealers: 'Dealers',
    subdealers: 'Subdealers',
    winCars: 'Purchased Cars',
    accounts: 'Accounts',
    auctionFees: 'Auction Fees',
    deliveryCost: 'Delivery Cost',
    statistics: 'Bids',
    watchlist: 'Watchlist',
    tools: 'Tools',
    settings: 'Settings',
    calculatorSettings: 'Calculator settings',
    calculatorSettingsDestinations: 'Destinations',
    calculatorSettingsVehicleTypes: 'Vehicle types',
    calculatorSettingsEngineTypes: 'Engine types',
  },

  // Common
  common: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    back: 'Back',
    refresh: 'Refresh',
    search: 'Search',
    actions: 'Actions',
    status: 'Status',
    contact: 'Contact',
    email: 'Email',
    phone: 'Phone',
    name: 'Name',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    loading: 'Loading...',
    noDataFound: 'No data found',
    total: 'Total',
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
    filters: 'Filters',
  },

  // Watchlist
  watchlist: {
    notFound: 'not found',
    remove: 'Remove from watchlist',
  },

  // Branches
  branches: {
    title: 'Branches Management',
    addBranch: 'Add Branch',
    editBranch: 'Edit Branch',
    createBranch: 'Create New Branch',
    branchName: 'Branch Name',
    branchCode: 'Branch Code',
    location: 'Location',
    country: 'Country',
    city: 'City',
    address: 'Address',
    totalBranches: 'Total Branches',
    activeBranches: 'Active Branches',
    totalManagers: 'Total Managers',
    totalDealers: 'Total Dealers',
    totalSubdealers: 'Total Subdealers',
    created: 'Created',
    backToBranches: 'Back to Branches',
    noBranchesFound: 'No branches found',
    deleteBranchConfirm: 'Are you sure you want to delete branch',
  },

  // Managers
  managers: {
    title: 'Managers Management',
    addManager: 'Add Manager',
    editManager: 'Edit Manager',
    createManager: 'Create New Manager',
    firstName: 'First Name',
    lastName: 'Last Name',
    assignToBranch: 'Assign to Branch',
    totalManagers: 'Total Managers',
    georgiaManagers: 'Georgia Branch',
    dubaiManagers: 'Dubai Branch',
    armeniaManagers: 'Armenia Branch',
    activeBids: 'Active Bids',
    monthlyRevenue: 'Monthly Revenue',
    wonAuctions: 'Won Auctions',
    backToManagers: 'Back to Managers',
    noManagersFound: 'No managers found',
    deleteManagerConfirm: 'Are you sure you want to delete manager',
  },

  // Dealers
  dealers: {
    title: 'Dealers Management',
    addDealer: 'Add Dealer',
    editDealer: 'Edit Dealer',
    createDealer: 'Create New Dealer',
    totalDealers: 'Total Dealers',
    georgiaDealers: 'Georgia Dealers',
    dubaiDealers: 'Dubai Dealers',
    armeniaDealers: 'Armenia Dealers',
    assignToManager: 'Assign to Manager',
    totalSubdealers: 'Total Subdealers',
    totalSpent: 'Total Spent',
    successRate: 'Success Rate',
    myBids: 'My Bids & Cars',
    subdealersBids: 'Subdealers Bids & Cars',
    allBids: 'All Bids & Cars',
    myActiveBids: 'My Active Bids',
    subdealersActiveBids: 'Subdealers Active Bids',
    totalCarsWon: 'Total Cars Won',
    backToDealers: 'Back to Dealers',
    noDealersFound: 'No dealers found',
    deleteDealerConfirm: 'Are you sure you want to delete dealer',
    deleteDealer: 'Delete Dealer',
    loadingList: 'Loading dealers...',
    filtersActiveSuffix: 'filter(s) active',
    quickSearchPlaceholder: 'Search by Name, Username, Email, or Phone...',
    ctrlFHint: 'Ctrl+F / ⌘F',
    advancedFilters: 'Advanced Filters',
    branchFilterPh: 'Branch',
    managerFilterPh: 'Manager',
    allBranches: 'All Branches',
    allManagers: 'All Managers',
    clearFilters: 'Clear Filters',
    pageTotalShowing: 'Showing',
    pageTotalOf: 'of',
    pageTotalLabel: 'total',
    auctionAccountsTitle: 'Auction Accounts',
    auctionAccountsRequired:
      'Please select at least one primary auction account (Copart, IAAI, Manheim, or ACV).',
    passwordLeaveBlank: 'Password (leave empty to keep current)',
    passwordLabel: 'Password',
    phoneLabel: 'Phone',
    selectBranch: 'Select branch',
    selectManager: 'Select manager',
    toggleOn: 'On',
    toggleOff: 'Off',
    phFirst: 'e.g., Nikoloz',
    phLast: 'e.g., Baratashvili',
    phUsername: 'e.g., dealer.ge1',
    phEmail: 'dealer@bidmanager.com',
    phPhone: '+995 555 777 777',
    accountAmPlaceholder: '🇬🇪 GE Account',
    accountUsOptional: '🇺🇸 US Account (Optional)',
    noneOption: 'None',
    unknownBranch: 'Unknown Branch',
    bidLimitLabel: 'Bid Limit',
    activeBidsAmountLabel: 'Active Bids Amount',
    activeBidsSumLimitLabel: 'Active Bids Sum Limit',
    purchasedCarsLimitLabel: 'Purchased Cars Limit',
    lotsEventSettingLabel: 'Lots Event Setting',
    purchasedLotsSettingLabel: 'Purchased Lots Setting',
    showCalculatorWidget: 'Show Calculator Widget',
    showHelperTool: 'Show Helper Tool',
    showDiscountRow: 'Show Discount Row',
    fixedDiscountAmount: 'Fixed Discount Amount ($)',
    fixedDiscountHelp: 'Fixed discount amount in USD',
    iaaiCanadaTitle: 'IAAI (Canada)',
    calculatorSettingsSection: 'Calculator Settings',
    auctionLimitsSection: 'Auction & limits',
    visibilityHide: 'Hide',
    visibilityShow: 'Show',
    visibilityPartlyShow: 'Partly Show',
    visibilityWinningLots: 'Winning Lots',
    colDealer: 'Dealer',
    colBranch: 'Branch',
    colManager: 'Manager',
    colContact: 'Contact',
    colSubdealers: 'Subdealers',
    colActiveBids: 'Active Bids',
    colTotalSpent: 'Total Spent',
    colCreatedBy: 'Created By',
    colActions: 'Actions',
    tooltips: {
      bidLimit: 'Maximum bid limit per one lot',
      activeBidsLimit: 'How many bids the user has already placed. For new users, set to 0',
      activeBidsSumLimit: 'Maximum total USD amount the user can bid across all lots',
      purchasedCarsLimit: 'Maximum number of cars the user can purchase',
      packageSlug: 'User package type',
      lotsEventSetting: 'Controls access to "My Bids" and "/dashboard" pages',
      purchasedLotsSetting: 'Controls access to view payment due and payment history pages',
    },
  },

  // Subdealers
  subdealers: {
    title: 'Subdealers Management',
    addSubdealer: 'Add Subdealer',
    editSubdealer: 'Edit Subdealer',
    createSubdealer: 'Create New Subdealer',
    assignToDealer: 'Assign to Dealer',
    dealer: 'Dealer',
    branch: 'Branch',
    manager: 'Manager',
    totalSpent: 'Total Spent',
    wonAuctions: 'Won Auctions',
    activeBids: 'Active Bids',
    backToSubdealers: 'Back to Subdealers',
    noSubdealersFound: 'No subdealers found',
    deleteSubdealerConfirm: 'Are you sure you want to delete subdealer',
    tooltips: {
      bidLimit: 'Maximum bid limit per one lot',
      activeBidsLimit: 'How many bids the user has already placed. For new users, set to 0',
      activeBidsSumLimit: 'Maximum total USD amount the user can bid across all lots',
      purchasedCarsLimit: 'Maximum number of cars the user can purchase',
      packageSlug: 'User package type',
      lotsEventSetting: 'Controls access to "My Bids" and "/dashboard" pages',
      purchasedLotsSetting: 'Controls access to view payment due and payment history pages',
    },
  },

  // Bids & Cars
  bids: {
    lotNumber: 'Lot Number',
    vin: 'VIN',
    vehicle: 'Vehicle',
    bidAmount: 'Bid Amount',
    status: 'Status',
    bidder: 'Bidder',
    subdealer: 'Subdealer',
    won: 'WON',
    active: 'ACTIVE',
    lost: 'LOST',
    totalBids: 'Total Bids',
    bidsAndCars: 'Bids & Cars',
    noBidsFound: 'No bids found',
  },

  layout: {
    footerBrand: 'Bidmanager System',
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    welcomeBack: 'Welcome Back',
    signIn: 'Sign In',
    profile: 'Profile',
    loginSubtitle: 'Car Auction Management System',
    usernamePlaceholder: 'Username',
    passwordPlaceholder: 'Password',
    signingIn: 'Signing in...',
    loginFailed: 'Login failed. Please check your credentials.',
    connectionError: 'Connection error. Please check your internet and try again.',
    forgotPasswordQuestion: 'Forgot Password?',
    forgotPasswordTitle: 'Forgot Password?',
    forgotPasswordHint: 'Enter your email or username to receive a password reset email.',
    resetByEmail: 'Reset by Email',
    resetByUsername: 'Reset by Username',
    emailPlaceholder: 'Enter your email',
    forgotUsernamePlaceholder: 'Enter your username',
    sending: 'Sending...',
    sendResetEmail: 'Send Reset Email',
    checkEmailTitle: 'Check Your Email',
    checkEmailBody:
      'If an account with that email/username exists, a password reset email has been sent. Please check your inbox and follow the instructions.',
    backToLogin: 'Back to Login',
    provideEmailOrUsername: 'Please provide email or username',
    enterEmailAddress: 'Please enter your email address',
    enterUsernameRequired: 'Please enter your username',
    requestFailedLater: 'Unable to process request. Please try again later.',
  },

  // Stats
  stats: {
    statistics: 'Statistics',
    dashboard: 'Dashboard',
  },

  // Dashboard
  dashboard: {
    systemAdminDashboard: 'System Administrator Dashboard',
    branchManagerDashboard: 'Branch Manager Dashboard',
    dealerDashboard: 'Dealer Dashboard',
    yourAuctionDashboard: 'Your Auction Dashboard',
    welcomeToDashboard: 'Welcome to Bidmanager Dashboard',
    welcomeBack: 'Welcome back',
    systemOverview: 'system',
    branchOverview: 'branch',
    activityOverview: 'activity',
    overview: 'overview',
    hereIsYour: "Here's your",
    downloadApp: 'Download App',
    downloadAppDesc: 'Get our mobile app for managing your auctions on the go',
    downloadNow: 'Download Now',
    yourManager: 'Your Manager',
    yourManagerDesc: 'Contact your dedicated manager for assistance',
    whatsapp: 'WhatsApp',
    viber: 'Viber',
    tarifPlan: 'Tarif Plan',
    basic: 'Basic',
    planLimits: '5 cars • $10,000 limit',
    upgradePlan: 'Upgrade Plan',
    quickOverview: 'Quick Overview',
    priceList: 'Price List',
    oneActive: '1 Active',
    twoOnline: '2 Online',
    twoActive: '2 Active',
    name: 'Name',
    user: 'User',
    account: 'Account',
    auction: 'Auction',
    activity: 'Activity',
    action: 'Action',
    managePriceLists: 'Manage Price Lists',
    manageSubdealers: 'Manage Subdealers',
    manageAccounts: 'Manage Accounts',
    online: 'Online',
    systemMetrics: 'System Metrics',
    branchPerformance: 'Branch Performance',
    yourActivity: 'Your Activity',
    totalBranches: 'Total Branches',
    activeBranchesWorldwide: 'Active branches worldwide',
    branchManagers: 'Branch managers',
    acrossAllBranches: 'Across all branches',
    totalRevenue: 'Total cars amount',
    totalPlatformRevenue: 'Total cars prices',
    mySubdealers: 'My Subdealers',
    activeInYourBranch: 'Active in your branch',
    currentlyInProgress: 'Currently in progress',
    byYourBranch: 'By your branch',
    currentlyBidding: 'Currently bidding',
    thisMonth: 'This month',
    totalBidsPlaced: 'Total bids placed',
    totalWonAuctions: 'Total auctions won',
  },

  // Form validation
  validation: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    passwordMismatch: 'Passwords do not match',
    minLength: 'Minimum length is',
    maxLength: 'Maximum length is',
  },

  // Notifications
  notifications: {
    createSuccess: 'Successfully created',
    updateSuccess: 'Successfully updated',
    deleteSuccess: 'Successfully deleted',
    error: 'An error occurred',
  },

  toolsPage: {
    title: 'Tools & Calculators',
    subtitle: 'Useful tools and calculators for managing your auction business',
    vehicleImportCalculator: 'Vehicle Import Calculator',
    vehicleImportDesc:
      'Calculate total import costs for vehicles from IAAI, Copart, and Manheim auctions. Supports Armenia and Georgia with country-specific tax calculations and user discounts.',
    georgianCustomsCalculator: 'Georgian Customs Calculator',
    georgianCustomsDesc:
      'Calculate Georgian customs fees for vehicle registration including excise tax, import tax, and registration fees.',
    comingSoon: 'Coming Soon',
    profitCalculator: 'Profit Calculator',
    profitCalculatorDesc: 'Calculate profit margins and ROI for auction purchases',
    shippingCalculator: 'Shipping Calculator',
    shippingCalculatorDesc: 'Estimate shipping costs from auction to your location',
  },

  toolsVehicleImport: {
    title: 'Vehicle Import Cost Calculator',
    chipGeorgia: 'Georgia',
    chipArmenia: 'Armenia',
    countryRequired: 'Country',
    countryArmenia: 'Armenia',
    countryGeorgia: 'Georgia',
    destination: 'Destination',
    destinationPoti: 'Poti',
    destinationBatumi: 'Batumi',
    resultDestinationSurcharge: 'Destination surcharge',
    auctionRequired: 'Auction',
    vehiclePriceUsd: 'Vehicle Price (USD)',
    yearRequired: 'Year',
    locationOptional: 'Location (optional)',
    searchLocationPlaceholder: 'Search location...',
    engineTypeRequired: 'Engine Type',
    fuelGasoline: 'Gasoline',
    fuelDiesel: 'Diesel',
    fuelHybrid: 'Hybrid',
    fuelElectric: 'Electric',
    engineVolumeCc: 'Engine Volume (cc)',
    vehicleTypeRequired: 'Vehicle Type',
    scaleSedan: 'Sedan',
    scaleTruck: 'Truck',
    scaleMotorcycle: 'Motorcycle',
    scaleQuadBike: 'Quad Bike',
    scaleSnowmobile: 'Snowmobile',
    userTypeRequired: 'User Type',
    userCompany: 'Company',
    userIndividual: 'Individual',
    highClearanceVehicle: 'High Clearance Vehicle',
    withoutVatAah: 'Without VAT (AAH)',
    hybridNash: 'Hybrid: ICE power exceeds max 30-min electric motor power',
    onePointTwoCoefficient: '1.2 coefficient (commission)',
    includeInsurance: 'Include Insurance',
    customTransportPrice: 'Custom Transport Price (USD)',
    calculating: 'Calculating...',
    geoChecking: 'Checking location...',
    calculate: 'Calculate',
    resultsTitle: 'Calculation Results',
    resultsInputSummary: 'Your inputs (for reference)',
    calculationTimestamp: 'Calculated at',
    exchangeRatesPending:
      'Exchange rates (USD, EUR, AMD) will appear in the results when the calculation provides them.',
    previewFobEstimate: 'Auction Fee estimate (live)',
    previewTransportEstimate: 'Transport estimate (live)',
    exchangeRatesAtCalculation: 'Exchange rates at calculation time (USD / EUR / AMD)',
    calculationTimestampUtc: 'Time (UTC)',
    monthDayHint: 'Month / Day',
    vehicleMonth: 'Month (first registration)',
    vehicleDay: 'Day (first registration)',
    armeniaDateSection: 'First registration date (Armenia)',
    armeniaExtraSection: 'Additional options (Armenia)',
    resultVehiclePrice: 'Vehicle Price',
    resultFob: 'Auction Fee',
    resultTransport: 'Transport',
    resultTransportListPrice: 'Transport (list price)',
    resultDiscountAmount: 'Dealer discount',
    resultInsurance: 'Insurance',
    resultBnph: 'Environmental tax (required)',
    resultCommission: 'Commission',
    resultImportTax: 'Import Tax',
    resultVatAah: 'VAT (AAH)',
    resultDiscount: 'Discount ({percent}%)',
    resultAppliedTo: 'Applied to',
    discountTargetTransport: 'Transport',
    resultTotalCost: 'Total Cost',
    calculationInProgress: '(Calculation in progress...)',
    transportWasStrikethrough: '(was {amount})',
    errorInvalidApi: 'The calculator returned an incomplete result. Please try again.',
    errorCalculationFailed: 'Calculation failed. Please check your inputs and try again.',
  },

  toolsGeorgianCustoms: {
    title: 'Georgian Car Customs Calculator',
    liveChip: 'LIVE',
    vehicleType: 'Vehicle Type',
    carType: 'Car Type',
    wheelPosition: 'Wheel Position',
    registrationType: 'Registration Type',
    typeCar: 'Car',
    typeMotorcycle: 'Motorcycle',
    carPetrolDiesel: 'Petrol/Diesel',
    carElectric: 'Electric',
    carHybrid: 'Hybrid',
    wheelLeft: 'Left',
    wheelRight: 'Right',
    regSingle: 'Single',
    regDouble: 'Double',
    engineVolumeCc: '(CC)',
    engineVolumeLiters: '(Liters)',
    engineVolumeLabel: 'Engine Volume',
    yearOfManufacture: 'Year of Manufacture',
    totalRegistrationCost: 'Total Registration Cost',
    vehicleAgeLabel: 'Vehicle Age',
    yearsSuffix: 'years',
    engineLabel: 'Engine',
    exciseRateLabel: 'Excise Rate',
    typeShort: 'Type',
    wheelShort: 'Wheel',
    registrationShort: 'Registration',
    exciseTax: 'Excise Tax',
    customsServiceTax: 'Customs Service Tax',
    registration: 'Registration',
    importTax: 'Import Tax',
    expertAssessment: 'Expert Assessment',
    customsDeclaration: 'Customs Declaration',
    internalTransit: 'Internal Transit (up to 60 days)',
  },

  calculatorDestinationsPage: {
    title: 'Georgia calculator - destinations',
    subtitle: 'Set extra port fees in USD. They are added to Georgia import estimates for each destination.',
    addDestination: 'Add destination',
    colSlug: 'ID',
    colLabel: 'Label',
    slugFormatHint: 'Use letters, numbers, and hyphens only (e.g. poti, batumi-port).',
    colPriceUsd: 'Price (USD)',
    colSort: 'Sort',
    loadError: 'Failed to load destinations',
    saveError: 'Failed to save destination',
    disabledOk: 'Destination removed from calculator (disabled)',
    removedOk: 'Destination deleted permanently',
    confirmRemoveTitle: 'Delete destination permanently?',
    confirmRemoveBody:
      'The destination {slug} will be removed for good. It will no longer appear in the import calculator or in this list. This cannot be undone.',
    confirmRemoveAction: 'Delete permanently',
    inactive: 'Disabled',
    activeLabel: 'Active',
    activeInCalculator: 'Active in calculator',
  },

  calculatorVehicleTypesPage: {
    title: 'Georgia calculator - vehicle types',
    subtitle:
      'Set fee (USD) added to US auction transport per vehicle category. The import calculator uses these values for Georgia.',
    addType: 'Add vehicle type',
    colId: 'Id',
    colName: 'Name',
    colPrice: 'Price',
    colCreatedAt: 'createdAt',
    colSlug: 'ID',
    colLabel: 'Label',
    slugFormatHint: 'Use letters, numbers, and hyphens only (e.g. sedan, custom-van).',
    colFeeUsd: 'Fee (USD)',
    colSort: 'Sort',
    emptyStateTitle: 'No vehicle types yet',
    emptyStateBody:
      'Add the categories and fees for Georgia import estimates. The calculator can show placeholder options until you add types here. Use the button above to create your first entry.',
    loadError: 'Failed to load vehicle types',
    saveError: 'Failed to save vehicle type',
    disabledOk: 'Vehicle type removed from calculator (disabled)',
    removedOk: 'Vehicle type deleted permanently',
    confirmRemoveTitle: 'Delete vehicle type permanently?',
    confirmRemoveBody:
      'The vehicle type {slug} will be removed for good. It will no longer appear in the import calculator or in this list. This cannot be undone.',
    confirmRemoveAction: 'Delete permanently',
    inactive: 'Disabled',
    activeLabel: 'Active',
    activeInCalculator: 'Active in calculator',
  },

  calculatorEngineTypesPage: {
    title: 'Georgia calculator - engine types',
    subtitle:
      'Set optional fee (USD) added to US auction transport per engine category. The import calculator uses these values for Georgia.',
    addType: 'Add engine type',
    colId: 'Id',
    colName: 'Name',
    colPrice: 'Price',
    colCreatedAt: 'createdAt',
    colSlug: 'ID',
    colLabel: 'Label',
    slugFormatHint: 'Use letters, numbers, and hyphens only (e.g. gasoline, plug-in-hybrid).',
    colFeeUsd: 'Fee (USD)',
    colSort: 'Sort',
    emptyStateTitle: 'No engine types yet',
    emptyStateBody:
      'Add the categories and optional fees for Georgia import estimates. The calculator can show placeholder options until you add types here. Use the button above to create your first entry.',
    loadError: 'Failed to load engine types',
    saveError: 'Failed to save engine type',
    disabledOk: 'Engine type removed from calculator (disabled)',
    removedOk: 'Engine type deleted permanently',
    confirmRemoveTitle: 'Delete engine type permanently?',
    confirmRemoveBody:
      'The engine type {slug} will be removed for good. It will no longer appear in the import calculator or in this list. This cannot be undone.',
    confirmRemoveAction: 'Delete permanently',
    inactive: 'Disabled',
    activeLabel: 'Active',
    activeInCalculator: 'Active in calculator',
  },

  // Delivery Cost
  deliveryCost: {
    title: 'Delivery Cost Management',
    addNew: 'Add New Location',
    editLocation: 'Edit Location',
    location: 'Location',
    fee: 'Fee',
    notes: 'Notes',
    auction: 'Auction',
    country: 'Country',
    armenia: 'Armenia',
    georgia: 'Georgia',
    auctionCopart: 'Copart',
    auctionIaai: 'IAAI',
    auctionManheim: 'Manheim',
    statsCopart: 'Copart:',
    statsIaai: 'IAAI:',
    statsManheim: 'Manheim:',
    totalLocations: 'Total Locations',
    searchLocation: 'Search Location',
    searchPlaceholder: 'e.g., Atlanta, Houston...',
    addNotes: 'Add notes...',
    notesPlaceholder: 'Optional notes about this location...',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete this delivery cost? This action cannot be undone.',
    createSuccess: 'Delivery cost created successfully',
    updateSuccess: 'Delivery cost updated successfully',
    deleteSuccess: 'Delivery cost deleted successfully',
    loadError: 'Failed to load delivery costs',
    saveError: 'Failed to save delivery cost',
    deleteError: 'Failed to delete delivery cost',
    validationError: 'Location and Fee are required',
  },

  auctionFeesPage: {
    fetchFailed: 'Failed to fetch fees',
    fetchError: 'Error fetching auction fees',
    deleted: 'Fee deleted successfully',
    deleteFailed: 'Failed to delete fee',
    deleteError: 'Error deleting fee',
    subtitle: 'Manage auction fees for Armenia and Georgia',
    addNewFee: 'Add New Fee',
    totalFees: 'Total Fees',
    allCountries: 'All Countries',
    armenia: 'Armenia',
    georgia: 'Georgia',
    currentView: 'Current View',
    tabArmenia: 'Armenia',
    tabGeorgia: 'Georgia',
    priceFrom: 'Price From *',
    priceTo: 'Price To * (0 = unlimited)',
    biddingFee: 'Bidding Fee',
    gateFee: 'Gate Fee',
    virtualBidFee: 'Virtual Bid Fee',
    brokerFee: 'Broker Fee',
    percentLabel: 'Percent (%)',
    percentColumn: 'Percent',
    isPercentBased: 'Is Percent Based',
    editFee: 'Edit Auction Fee',
    addFee: 'Add New Auction Fee',
    noFeesFor: 'No fees found for',
    typePercent: 'Percent',
    typeFixed: 'Fixed',
    feeType: 'Type',
    virtualBidShort: 'Virtual Bid',
    priceFromCol: 'Price From',
    priceToCol: 'Price To',
    confirmDeleteTitle: 'Confirm Delete',
    confirmDeleteBody: 'Are you sure you want to delete fee ID',
    feeUpdated: 'Fee updated successfully',
    feeCreated: 'Fee created successfully',
    saveFailed: 'Failed to save fee',
    saveError: 'Error saving fee',
  },
};

